import { memo } from 'react';
import { Alert } from 'foundations-components/transitional/components/Alert';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import PrimaryMessageContentSection from '../primary-message/components/PrimaryMessageContentSection';
import LocationAttachment from '../attachments/LocationAttachment';
import ContactAttachment from '../attachments/ContactAttachment';
import FileAttachmentsFooter from '../attachments/FileAttachmentsFooter';
import styled from 'foundations-theming/utils';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledFooterContainer = styled.div.withConfig({
  displayName: "AttachmentsFooter__StyledFooterContainer",
  componentId: "sc-1y4bdo6-0"
})(({
  theme
}) => {
  return {
    width: '100%',
    'padding-left': `${theme.space['600']}`
  };
});
const renderLocationAttachmentSection = locationMetadata => {
  if (!locationMetadata) return null;
  return /*#__PURE__*/_jsx(PrimaryMessageContentSection, {
    children: /*#__PURE__*/_jsx(LocationAttachment, {
      locationMetadata: locationMetadata
    })
  });
};
const renderContactsAttachmentSection = contactsMetadata => {
  if (!contactsMetadata) return null;
  return /*#__PURE__*/_jsx(PrimaryMessageContentSection, {
    children: contactsMetadata.map(contact => /*#__PURE__*/_jsx(ContactAttachment, {
      contactMetadata: contact
    }, JSON.stringify(contact)))
  });
};
const renderFileAttachmentsSection = (genericChannelId, fileAttachments) => {
  return fileAttachments && fileAttachments.size > 0 ? /*#__PURE__*/_jsx(PrimaryMessageContentSection, {
    children: /*#__PURE__*/_jsx(FileAttachmentsFooter, {
      fileAttachments: fileAttachments,
      genericChannelId: genericChannelId
    })
  }) : null;
};
const renderUnsupportedContentAttachmentSection = unsupportedContent => {
  if (!unsupportedContent) return null;
  return /*#__PURE__*/_jsx(PrimaryMessageContentSection, {
    children: /*#__PURE__*/_jsx(Alert, {
      type: "warning",
      marginBlockEnd: "200",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "conversations-inbox-message-history.common-message.unsupportedContentMessage_jsx",
        elements: {
          UILink: Link
        }
      })
    })
  });
};
const AttachmentsFooter = ({
  fileAttachments,
  locationMetadata,
  contactsMetadata,
  unsupportedContent,
  genericChannelId
}) => {
  return /*#__PURE__*/_jsxs(StyledFooterContainer, {
    children: [renderLocationAttachmentSection(locationMetadata), renderContactsAttachmentSection(contactsMetadata), renderFileAttachmentsSection(genericChannelId, fileAttachments), renderUnsupportedContentAttachmentSection(unsupportedContent)]
  });
};
AttachmentsFooter.displayName = 'AttachmentFooter';
export default /*#__PURE__*/memo(AttachmentsFooter);